module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7Uyyv"))).then(() => module.bundle.root('1iHdE'));